import { render } from "./daily-fund-chart.vue?vue&type=template&id=180f29e7"
import script from "./daily-fund-chart.vue?vue&type=script&lang=ts"
export * from "./daily-fund-chart.vue?vue&type=script&lang=ts"
script.render = render

export default script